import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import SingleRadioBoxField from './SingleRadioBoxField';
import crossGreyIcon from 'assets/images/icons/cross-grey.svg';

const SortingDropdown = ({
  toggleComponent,
  options,
  scrollable,
  // shrink,
  drop,
  align,
  name,
  directionKey,
  selectedValue,
  selectedDirection,
  // displayName,
  handleChange,
  toggleClasses,
  fullWidth,
}) => {
  const { t } = useTranslation();
  // const shrinkLabel = shrink ? ' shrink-label' : '';

  const onRootClose = (meta) => {
    if (meta.source === 'rootClose') {
      // const tempNested = [...nestedShow].fill(false);
      // setNestedShow(tempNested);
    }
  };

  return (
    <div className='sorting-select'>
      <Dropdown drop={drop ?? 'down'} autoClose={true} onToggle={(_, meta) => onRootClose(meta)}>
        <Dropdown.Toggle
          id='dropdown-autoclose-true'
          variant='none'
          className={`rounded-sm cursor-pointer ${toggleClasses ?? ''}`}
          as='div'
        >
          {toggleComponent}
          {/* {label && <label className='theme-size-0_9 cursor-pointer'>{t(label)}</label>}
                <img src={chevronGreyIcon} className={`rotate-180`} /> */}
        </Dropdown.Toggle>

        <Dropdown.Menu
          className={`${fullWidth ? 'w-100' : ''} px-1`}
          align={align ?? 'start'}
          as='div'
        >
          <div className='px-2 pt-2'>
            <label className='theme-size-0_9 mb-1'>Sorting</label>
            {[
              { displayValue: 'Ascending', value: 'asc' },
              { displayValue: 'Descending', value: 'desc' },
            ].map(({ displayValue, value }, i) => (
              <SingleRadioBoxField
                key={i}
                name={directionKey + i}
                text={<span>{t(displayValue)}</span>}
                value={value === selectedDirection}
                handleChange={() => {
                  console.log({ value });

                  handleChange(directionKey, value);
                }}
                shrink
                classes='width-max-content mb-3'
              />
            ))}
          </div>

          <label className='px-2 theme-size-0_9 mb-1'>Columns</label>
          <div className={`px-2 ${scrollable ? 'scrollable-options' : ''}`}>
            {(() => {
              if (options.length === 0) {
                return (
                  <Dropdown.Item as='div' disabled className='d-block text-center px-1 text-muted'>
                    {t('text_empty_list')}
                  </Dropdown.Item>
                );
              }

              return options.map((option, i) => (
                <Fragment key={i}>
                  <Dropdown.Item
                    as='div'
                    className={`px-1 cursor-pointer${
                      selectedValue === option.value ? ' selected' : ''
                    }`}
                    onClick={() => handleChange(name, option.value)}
                    disabled={option.disabled ?? false}
                  >
                    {option.icon && <img src={option.icon} />}
                    {t(option.displayValue)}
                  </Dropdown.Item>
                </Fragment>
              ));
            })()}
          </div>
        </Dropdown.Menu>
      </Dropdown>
      {selectedValue !== '' && (
        <img
          src={crossGreyIcon}
          className='cursor-pointer'
          onClick={() => handleChange(name, '')}
        />
      )}
    </div>
  );
};

SortingDropdown.propTypes = {
  toggleComponent: PropTypes.object.isRequired,
  toggleClasses: PropTypes.string,
  options: PropTypes.array.isRequired,
  error: PropTypes.string,
  touched: PropTypes.bool,
  scrollable: PropTypes.bool,
  shrink: PropTypes.bool,
  drop: PropTypes.string,
  align: PropTypes.string,
  name: PropTypes.string.isRequired,
  directionKey: PropTypes.string.isRequired,
  selectedValue: PropTypes.string,
  selectedDirection: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
};

export default SortingDropdown;
